import { useState } from "react";
import { Layout, Space, notification } from "antd";

import SandboxBanner from "../components/SandboxBanner";
import ParametersForm from "../components/ParametersForm";
import TransactionsTable from "../components/TransactionsTable";
import { useTransactions } from "../hooks/useTransactions";
import { TransactionParameters } from "../types";

const { Content } = Layout;

const BankTransactionSandbox: React.FC = () => {
  const [customerEmail, setCustomerEmail] = useState<string>("");

  const {
    transactions,
    loading,
    selectedRowIds,
    setSelectedRowIds,
    generateTransactions,
    removeTransaction,
    removeSelectedTransactions,
    clearTransactions,
    submitTransactions,
  } = useTransactions();

  const handleGenerate = (params: TransactionParameters, email: string) => {
    const totalAfterGeneration = transactions.length + params.count;

    if (totalAfterGeneration > 100) {
      notification.warning({
        message: "Transaction Limit",
        description: `You can only create up to 100 transactions. You currently have ${transactions.length} and tried to add ${params.count} more.`,
      });
      return;
    }

    setCustomerEmail(email);
    generateTransactions(params);
  };

  const handleSubmit = () => {
    submitTransactions(customerEmail);
  };

  return (
    <Layout style={{ overflowY: "auto" }}>
      <Content
        style={{ padding: "20px", maxWidth: "1200px", margin: "0 auto" }}
      >
        <SandboxBanner />

        <Space direction="vertical" size="large" style={{ width: "100%" }}>
          <ParametersForm onGenerate={handleGenerate} loading={loading} />

          <TransactionsTable
            transactions={transactions}
            selectedRowIds={selectedRowIds}
            onSelectChange={setSelectedRowIds}
            onRemoveSelected={removeSelectedTransactions}
            onRemoveTransaction={removeTransaction}
            onClear={clearTransactions}
            onSubmit={handleSubmit}
            loading={loading}
          />
        </Space>
      </Content>
    </Layout>
  );
};

export default BankTransactionSandbox;
